import { useCallback, useState } from 'react';

export default () => {
  const [selected, setSelected] = useState([]);

  const isSelected = ({ id }) => selected.some((item) => item.id === id);

  const handleUnselectAll = () => {
    setSelected([]);
  };

  const handleSelect = useCallback(
    (value) => (event) => {
      event.stopPropagation();
      setSelected((state) =>
        state.some(({ id }) => id === value.id)
          ? state.filter(({ id }) => id !== value.id)
          : [...state, value]
      );
    },
    []
  );

  return {
    selectedRows: selected,
    isSelected,
    onUnselectAll: handleUnselectAll,
    onSelect: handleSelect,
  };
};
